import { Grid } from '@mui/material';
import { TimerangePicker } from 'components/inputs/TimerangePicker';
import UnitSelector from 'components/inputs/UnitSelector/UnitSelector';
import { useTranslation } from 'react-i18next';

export function UnitDetailTopbar({ unitSelectorProps, timerangePickerProps, showRangePicker = true }) {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2} pt={1} pb={2} justifyContent="space-between">
      <Grid item xs={12} sm={5} sx={{ maxWidth: { xs: '100%', sm: '375px' } }}>
        <UnitSelector
          units={unitSelectorProps.units}
          selectedUnitExtId={unitSelectorProps.selectedUnitExtId}
          handleChange={unitSelectorProps.onChange}
          fieldLabel={t('entities:greenerUnit.nameSingular')}
        />
      </Grid>

      {showRangePicker && (
        <Grid item xs={12} sm={6} md={5}>
          <TimerangePicker {...timerangePickerProps} style={{ width: '100%' }} />
        </Grid>
      )}
    </Grid>
  );
}
